import { createRouter, createWebHashHistory } from "vue-router";

import signHome from "@/pages/sign/index.vue";
import sign from "@/pages/sign/sign/index.vue";
import signstatistics from "@/pages/sign/statistics/index.vue";
import signapproveList from "@/pages/sign/approve/index.vue";
import signApproveInfo from "@/pages/sign/approve/signApprove.vue";
import leaveHome from "@/pages/leave/index.vue";
import leaveApplyList from "@/pages/leave/todo/applyList.vue";
import leaveApproveList from "@/pages/leave/leaveapprove/index.vue";
import clockHomeView from "@/pages/clockin/index.vue";
import onClockView from "@/pages/clockin/clockInView.vue";
import clockstatistics from "@/pages/clockin/statisticsView.vue";

const routes = [
  //  签到
  {
    path: "/signhome",
    name: "signhome",
    component: signHome,
    children: [
      {
        path: "/signhome",
        redirect: "/signhome/sign",
      },
      {
        path: "sign",
        name: "sign",
        component: sign,
      },
      {
        path: "statistics",
        name: "statistics",
        component: signstatistics,
      },
      {
        path: "signapprove",
        name: "approve",
        component: signapproveList,
      },
    ],
  },
  // 打卡
  {
    path: "/clockin",
    name: "clockin",
    component: clockHomeView,
    children: [
      {
        path: "/clockin",
        redirect: "/clockin/onclock",
      },
      {
        path: "onclock",
        name: "onclock",
        component: onClockView,
      },
      {
        path: "statistics",
        name: "statistics",
        component: clockstatistics,
      },
    ],
  },
  {
    path: "/sign/approveInfo/:signId",
    name: "approveinfo",
    component: signApproveInfo,
  },
  {
    path: "/sign/relocation/:locationInfo",
    name: "relocation",
    component: () => import("@/pages/sign/sign/reLocation.vue"),
  },
  //  请假
  {
    path: "/leave",
    name: "Leave",
    component: leaveHome,
    children: [
      {
        path: "/leave",
        redirect: "/leave/todo",
      },
      {
        path: "todo",
        name: "todo",
        component: () => import("@/pages/leave/todo/index.vue"),
      },
      {
        path: "approvelist",
        name: "approvelist",
        component: leaveApproveList,
      },
    ],
  },

  {
    path: "/leave/approve/:itemData",
    name: "leaveapprove",
    component: () => import("@/pages/leave/leaveapprove/approve.vue"),
  },
  {
    path: "/leave/applyList",
    name: "applyList",
    component: leaveApplyList,
  },
  // 补卡
  {
    path: "/buka",
    name: "reissue",
    component: () => import("@/pages/reissue/index.vue"),
  },
  {
    path: "/bukalist",
    name: "reissuelist",
    component: () => import("@/pages/reissue/reissueList.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
